export default __webpack_public_path__ + "static/media/metamasklogo.93183342.png";